// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603311503/js/" + chunkId + "." + {"44":"66850b4c","225":"6fbccd22","481":"b29f128b","486":"f3d0362b","770":"6df6c6e7"}[chunkId] + ".0.18619387240987484.chunk.js";
};